export class LODManager {
  constructor(distance = 45) {
    this.distance = distance;
  }

  update(root, camera, lowMode = false) {
    if (!root || !camera) return;
    const threshold = lowMode ? this.distance * 0.7 : this.distance;
    for (const child of root.children) {
      if (!child.userData.optionalDetail) continue;
      child.visible = child.position.distanceTo(camera.position) <= threshold;
    }
  }
}
